


<form [formGroup]="form">
  <mat-form-field class="procedureSelection">
    <input
      type="text"
      #procedureSel
      matInput
      placeholder="Práctica"
      formControlName="Procedure"
      [matAutocomplete]="procedureSelection"
    />
    <mat-autocomplete
      [displayWith]="displayPosiblePracticesFn"
      #procedureSelection="matAutocomplete"
    >
      <mat-option
        *ngFor="let procedure of filterCompletePosiblePractices | async"
        [value]="procedure"
      >
        {{ procedure.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <mat-spinner  *ngIf="loading" ></mat-spinner>

  <div *ngIf="!loading && items.length > 0; s">
    <table mat-table [dataSource]="items">
      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th class="val-cell" mat-header-cell *matHeaderCellDef>Nombre</th>
        <td class="val-cell" mat-cell *matCellDef="let element">
          {{ getName(element) }}
        </td>
        <td class="val-cell" mat-footer-cell *matFooterCellDef>
          <b>Total </b>
        </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="quantity">
        <th class="val-cell" mat-header-cell *matHeaderCellDef>Cantidad</th>
        <td class="val-cell" mat-cell *matCellDef="let element">
          {{ getQuantity(element) }}
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="amount">
        <th class="val-cell" mat-header-cell *matHeaderCellDef>
          Total paciente
        </th>
        <td class="val-cell" mat-cell *matCellDef="let element">
          ${{ getPatientAmount(element) }}
        </td>
        <td class="val-cell" mat-footer-cell *matFooterCellDef>
          <b> ${{ getTotal() }} </b>
        </td>
      </ng-container>

      <ng-container matColumnDef="star">
        <th
          class="val-cell"
          mat-header-cell
          class="search-table-header"
          *matHeaderCellDef
        ></th>
        <td
          class="val-cell"
          mat-cell
          class="search-table-cell"
          *matCellDef="let element"
        >
          <button (click)="edit(element)" type="button" mat-icon-button>
            <mat-icon>edit</mat-icon>
          </button>

          <button
            *ngIf="canRemove(element)"
            (click)="remove(element)"
            type="button"
            mat-icon-button
          >
            <mat-icon>delete</mat-icon>
          </button>
        </td>
        <td class="val-cell" mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <tr
        class="val-cell"
        mat-header-row
        *matHeaderRowDef="displayedColumns"
      ></tr>
      <tr
        class="val-cell"
        mat-row
        *matRowDef="let row; columns: displayedColumns"
      ></tr>
      <tr
        class="val-cell"
        mat-footer-row
        *matFooterRowDef="displayedColumns"
      ></tr>
    </table>
  </div>
</form>
